<!-- Preview modus: draai de HTML in een geïsoleerde iframe zodat de
     eigen styles/scripts van het widget werken zonder de cockpit-UI te
     raken. -->
<div class="html-block-preview" [class.selected]="isSelected">
  <div *ngIf="isEmpty()" class="html-block-empty">
    <p class="italic text-gray-400 mb-1">Leeg HTML-blok</p>
    <p class="text-xs text-gray-500">Selecteer dit blok en plak in de editor rechts je HTML, CSS en JavaScript.</p>
  </div>

  <iframe
    *ngIf="!isEmpty()"
    class="html-block-iframe"
    [srcdoc]="getIframeSrcdoc()"
    sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
    title="HTML blok preview"
  ></iframe>
</div>
